import { useEffect, useState } from "react"
import { useLocation, useParams } from "react-router-dom"
import { getParams, UrlParams } from "./paramsStorage"

export const initialParams = Object.freeze<UrlParams>({
  orgForm: "enk",
  medMva: "medMva",
})

export function useCustomParams(): UrlParams {
  const params = useParams()
  const { pathname } = useLocation()
  const urlParams = (getParams() as UrlParams) ?? initialParams

  const [parameter, setParameter] = useState<UrlParams>(urlParams)

  useEffect(() => {
    const { orgForm = urlParams.orgForm, medMva = urlParams.medMva } = params
    const o = { orgForm, medMva }
    setParameter(o)
  }, [params, pathname])

  return parameter
}
